<div class="homeCard" routerLink="/ehm" fragment="ehm-title">
  <h2 class="title">
    智保網
    <img class="titleLogo" src="assets/images/laptop_ehm.png" />
  </h2>
  <p>智能院舍, 藥物管理, 電子派藥</p>
</div>
